// extracted by mini-css-extract-plugin
export default {"frame":"Presentation_frame__W559H","embed":"Presentation_embed__TM2OT"};